import { React, useEffect, useState } from 'react';
import logo from '../../assets/logo-3.png';
import GalaxyAnimation from './GalaxyAnimation';
import lumindLogo from '../../assets/logo.jpg';
import Hero from './Hero';
import CustomVideoPlayer from './CustomVideoPlayer';
import caption_logo from '../../assets/caption_logo.vtt';
import caption_logo_1 from '../../assets/caption_logo_1.vtt';
import bgLogoVideo from '../../assets/logo.mp4';
import ParticleTextCanvas from "./ParticleTextCanvas";
import hexagonImg from '../../assets/hexagon-main.png';
import CustomMusicPlayer from './CustomMusicPlayer';
import bgMusic from '../../assets/remix_background_music.mp3';
import bgIntroVideo from '../../assets/introVideo.mp4';
import CurvedLoop from './CurvedLoop';
import Globe3D from './Globe3D';

export const Branding = ({ className }) => {
  const data = [
    {
      id: "01",
      heading: "Digital Branding",
      desc: "I always want to create quality products.",
    },
    {
      id: "02",
      heading: "Efficient Performance",
      desc: "High performance is also important in programming.",
    },
    {
      id: "03",
      heading: "Outstanding Skills",
      desc: "Outstanding skills will be the core to develop programs.",
    },
  ];


  const galaxyImages = [
    logo,
    hexagonImg,
    lumindLogo,
  ];
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleResize = () => {
      setIsMobile(mediaQuery.matches);
    };

    handleResize();
    mediaQuery.addEventListener("change", handleResize);

    return () => {
      mediaQuery.removeEventListener("change", handleResize);
    };
  }, []);

  return (
    <>
      <section
        className={`branding ${className}`}
        style={{ marginTop: "100px" }}
      >
        <div
          className="branding-container"
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
            gap: "20px",
            width: "100%",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: isMobile ? "16px" : "0 16px",
            boxSizing: "border-box",
            marginTop: "21px",
          }}
        >
          {data.map((value) => (
            <div
              key={value.id}
              className="box"
              style={{
                display: "flex",
                gap: "30px",
                padding: isMobile ? "20px 0" : "30px",
              }}
            >
              <div className="text">
                <h1
                  style={{
                    fontSize: "48px",
                    color: "#ffffff",
                    margin: 0,
                  }}
                >
                  {value.id}
                </h1>
              </div>

              <div className="para">
                <h2
                  style={{
                    color: "#fff",
                    marginBottom: "10px",
                  }}
                >
                  {value.heading}
                </h2>

                <p
                  style={{
                    color: "#fff",
                    lineHeight: "1.6",
                  }}
                >
                  {value.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <div style={{ backgroundColor: '#fff', color: 'white' }}>
        <CurvedLoop
          marqueeText="BE ✦ CREATIVE ✦ WITH ✦ DLUONGTA ✦ TSCEND ✦ "
          speed={1.5}
          mobileSpeed={4.3}
        />
      </div>
      <Globe3D />
      <GalaxyAnimation
        text="DINH LUONG TA"
        imageUrls={galaxyImages}
      />
      <ParticleTextCanvas />
      <CustomVideoPlayer src={bgIntroVideo} captionSrc={caption_logo_1} />
      <CustomVideoPlayer src={bgLogoVideo} captionSrc={caption_logo} />
      <CustomMusicPlayer src={bgMusic} title="Remix Background Music" artist="DLUONGTA" useImage={true} cover={hexagonImg} />
      <Hero />
    </>
  );
};
